import React from 'react';

const maxCharactersForMobileLine = 50;
const textHeightPlusPadding = 25;
const numberOfLinesWhenTruncated = 4;
class ReviewHelper {

    static getHighlightedText = (reviewId, text, searchKeyWord) => {
      if (!searchKeyWord) {
        return text;
      }
      const parts = text.split(new RegExp(`(${searchKeyWord})`, 'gi'));
      return (
        <span key={`search_by_${searchKeyWord}`}>
          {parts.map((part, index) => (part.toLowerCase() === searchKeyWord.toLowerCase()
            ? <span key={`search_keyword_${reviewId}_${index}`} style={{ backgroundColor: 'rgba(249, 99, 2, 0.4)', fontWeight: 'bold' }}>{part}</span>
            : part))}
        </span>
      );
    };

    static getCalculatedReviewHeight = (reviewText) => {
      return (reviewText.length / maxCharactersForMobileLine) * textHeightPlusPadding;
    }

    static shouldTruncate = (reviewText) => {
      const charactersToTruncate = numberOfLinesWhenTruncated * maxCharactersForMobileLine;
      return (reviewText && reviewText.length > charactersToTruncate);
    }

    static fetchRatingProperties = (rating) => {
      return { totalReviews: rating, averageRating: rating };
    };

    static formatSubmissionDate = (date) => {
      if (!date) { return date; }
      let dateObj = new Date(Date.parse(date));
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return dateObj.toLocaleDateString('en-US', options);
    }
}

export default ReviewHelper;
